import React from 'react';
import Skeleton from 'react-loading-skeleton';

const GraphSkeleton = ({ title }) => {
  return (
    <div className="card card-xl-stretch mb-xl-8">
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="card-label fw-bold fs-3 mb-1">{title || <Skeleton width={150} />}</span>
        </h3>
      </div>
      <div className="card-body">
        <Skeleton height={350} />
        <div className="d-flex justify-content-between mt-2">
          <Skeleton width={40} /> <Skeleton width={40} /> <Skeleton width={40} /> <Skeleton width={40} />
        </div>
      </div>
    </div>
  );
};

export default GraphSkeleton;
